const ChevronUp = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.354 14.854a.5.5 0 0 1-.708 0L12 10.207l-4.646 4.647a.5.5 0 0 1-.708-.708l5-5a.5.5 0 0 1 .708 0l5 5a.5.5 0 0 1 0 .708"
      clipRule="evenodd"
    />
  </>
)
export default ChevronUp
